import { Injectable } from '@angular/core';
import { SysmsgServicePkg } from './sysmsgPkg.service';

@Injectable({
  providedIn: 'root',
})
export class SysmsgService extends SysmsgServicePkg {
  constructor() {
    super();
  }
}
